import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import App from './App';
import './styles.css'; // Tailwind CSS
import './usePageTracking'; // Auto-track page views
import { AuthProvider } from './pages/admin/AuthContext';

// Lazy load public pages
const PackageDetailsPage = React.lazy(() => import('./PackageDetailsPage'));
const RamadanLandingPage = React.lazy(() => import('./pages/ramadan/RamadanLandingPage'));

// Lazy load admin pages
const AdminLayout = React.lazy(() => import('./pages/admin/AdminLayout'));
const Dashboard = React.lazy(() => import('./pages/admin/Dashboard'));
const DestinationsPage = React.lazy(() => import('./pages/admin/DestinationsPage'));
const PackagesPage = React.lazy(() => import('./pages/admin/PackagesPage'));
const AddPackagePage = React.lazy(() => import('./pages/admin/AddPackagePage'));
const PackagePriorityPage = React.lazy(() => import('./pages/admin/PackagePriorityPage'));
const ArticlesPage = React.lazy(() => import('./pages/admin/ArticlesPage'));
const ActivitiesPage = React.lazy(() => import('./pages/admin/ActivitiesPage'));
const SettingsPage = React.lazy(() => import('./pages/admin/SettingsPage'));
const LoginPage = React.lazy(() => import('./pages/admin/LoginPage'));

const PageLoader = () => (
  <div className="flex items-center justify-center min-h-screen">
    <div className="w-12 h-12 border-4 border-emerald-600 border-t-transparent rounded-full animate-spin"></div>
  </div>
);

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Suspense fallback={<PageLoader />}>
        <Routes>
          {/* Admin Dashboard Routes - wrapped with AuthProvider */}
          {/* Admin Dashboard Routes - Explicit flat routing to fix nested path issues */}
          {/* Dashboard */}
          <Route path="/admin" element={
            <AuthProvider><AdminLayout><Dashboard /></AdminLayout></AuthProvider>
          } />

          {/* Destinations */}
          <Route path="/admin/destinations" element={
            <AuthProvider><AdminLayout><DestinationsPage /></AdminLayout></AuthProvider>
          } />

          {/* Packages */}
          <Route path="/admin/packages" element={
            <AuthProvider><AdminLayout><PackagesPage /></AdminLayout></AuthProvider>
          } />

          {/* Packages Add */}
          <Route path="/admin/packages/add" element={
            <AuthProvider><AdminLayout><AddPackagePage /></AdminLayout></AuthProvider>
          } />

          {/* Packages Priority */}
          <Route path="/admin/packages/priority" element={
            <AuthProvider><AdminLayout><PackagePriorityPage /></AdminLayout></AuthProvider>
          } />

          {/* Articles */}
          <Route path="/admin/articles" element={
            <AuthProvider><AdminLayout><ArticlesPage /></AdminLayout></AuthProvider>
          } />

          {/* Activities */}
          <Route path="/admin/activities" element={
            <AuthProvider><AdminLayout><ActivitiesPage /></AdminLayout></AuthProvider>
          } />

          {/* Settings */}
          <Route path="/admin/settings" element={
            <AuthProvider><AdminLayout><SettingsPage /></AdminLayout></AuthProvider>
          } />
          <Route path="/login" element={<AuthProvider><LoginPage /></AuthProvider>} />
          <Route path="/package/:slug" element={<PackageDetailsPage />} />
          <Route path="/en/package/:slug" element={<PackageDetailsPage />} />
          {/* Ramadan Landing Page */}
          <Route path="/offers/ramadan" element={<RamadanLandingPage />} />
          {/* Main App (catch-all) */}
          <Route path="*" element={<App />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  </React.StrictMode>
);